module.exports = __webpack_public_path__ + "static/media/profile_placeholder_4.936f4af5.svg";